import { Typography } from '@mui/material'

interface SectionHeaderProps {
  title: string
}

const titleStyles = {
  fontSize: '16px',
  fontWeight: 700,
  color: '#333',
  mb: 2,
  textTransform: 'uppercase' as const,
  letterSpacing: '0.5px',
}

export const SectionHeader = ({ title }: SectionHeaderProps) => {
  return (
    <Typography variant='h6' sx={titleStyles}>
      {title}
    </Typography>
  )
}
